export default __webpack_public_path__ + "static/media/b1.f237ec17.png";